(function() {

  // ==========================================
  // VERIFICADOR DE DOMÍNIO E VALIDADE
  // ==========================================
  (function() {
    
  })();

  const SCAV_CONFIG = window.SCAV_DATA || { variants: [] };
  const storyProductVariants = SCAV_CONFIG.variants;

  function scavUnlock() {
    const overlay = document.getElementById('scav-video-popup-overlay');
    const productCard = document.getElementById('scav-story-product-card');
    
    if (overlay) {
      // Força z-index máximo para garantir que nada fique na frente
      overlay.style.setProperty('display', 'flex', 'important');
      overlay.style.setProperty('z-index', '2147483647', 'important');
      overlay.style.setProperty('position', 'fixed', 'important');
      
      document.querySelectorAll('.scav-story-video').forEach(video => {
        if (!video.src || video.src === "") {
          const realSrc = video.getAttribute('data-src');
          if (realSrc) {
            video.src = realSrc;
            const source = video.querySelector('source');
            if (source) source.src = realSrc;
            video.load();
          }
        }
      });
      overlay.classList.add('active');
    }
    if (productCard) {
      productCard.style.setProperty('display', 'flex', 'important');
      productCard.style.setProperty('z-index', '9999999', 'important');
    }
  }

  function scavLockClose() {
    ['scav-video-popup-overlay', 'scav-story-product-card', 'scav-mini-cart-sheet', 'scav-product-sheet'].forEach(id => {
      const el = document.getElementById(id);
      if (el) {
        el.style.setProperty('display', 'none', 'important');
        el.classList.remove('active');
      }
    });
    document.querySelectorAll('.scav-story-video').forEach(v => {
      v.pause();
      v.currentTime = 0;
    });
  }

  function updateStoryVariant() {
    const selectedOptions = Array.from(document.querySelectorAll('.scav-variant-option-selector:checked')).map(el => el.value);
    const matchedVariant = storyProductVariants.find(v => v.options.every((opt, i) => opt === selectedOptions[i]));
    if (!matchedVariant) return;

    const variantSelect = document.getElementById('scav-video-popup-variant-select');
    const priceVal = (matchedVariant.price / 100).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    
    const sheetPrice = document.getElementById('scav-sheet-price');
    const cardPrice = document.getElementById('scav-card-main-price');
    if (sheetPrice) sheetPrice.innerText = priceVal;
    if (cardPrice) cardPrice.innerText = priceVal;
    if (variantSelect) variantSelect.value = matchedVariant.id.toString();

    const sheetComp = document.getElementById('scav-sheet-compare-price');
    const cardComp = document.getElementById('scav-card-compare-price');
    const hasCompare = matchedVariant.compare_at_price > matchedVariant.price;
    
    if (hasCompare) {
      const compVal = (matchedVariant.compare_at_price / 100).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
      if (sheetComp) { sheetComp.innerText = compVal; sheetComp.style.display = 'inline-block'; }
      if (cardComp) { cardComp.innerText = compVal; cardComp.style.display = 'inline-block'; }
    } else {
      if (sheetComp) sheetComp.style.display = 'none';
      if (cardComp) cardComp.style.display = 'none';
    }

    if (matchedVariant.featured_image) {
      const imgElement = document.getElementById('scav-sheet-variant-image');
      if (imgElement) imgElement.src = matchedVariant.featured_image.src;
    }

    const addBtn = document.getElementById('scav-video-popup-add');
    if (addBtn) {
      addBtn.disabled = !matchedVariant.available;
      addBtn.innerText = matchedVariant.available ? "Adicionar ao Carrinho" : "Esgotado";
      addBtn.style.opacity = matchedVariant.available ? "1" : "0.5";
    }
  }

  window.removeItemFromCart = async function(id) {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: { [id]: 0 } })
    });
    refreshMiniCart();
  };

  async function refreshMiniCart() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const container = document.getElementById('scav-mini-cart-items-container');
    if (!container) return;

    const emptyMsg = document.getElementById('scav-mini-cart-empty-msg');
    const badge = document.getElementById('scav-cart-count-badge');
    const checkoutBtn = document.getElementById('scav-mini-cart-checkout-btn');

    if (cart.item_count > 0) {
      badge.innerText = cart.item_count;
      badge.style.visibility = 'visible';
      if (checkoutBtn) { checkoutBtn.disabled = false; checkoutBtn.style.opacity = "1"; checkoutBtn.style.cursor = "pointer"; }
    } else {
      badge.style.visibility = 'hidden';
      if (checkoutBtn) { checkoutBtn.disabled = true; checkoutBtn.style.opacity = "0.4"; checkoutBtn.style.cursor = "not-allowed"; }
    }

    if (cart.item_count === 0) {
      container.innerHTML = '';
      if (emptyMsg) emptyMsg.style.display = 'block';
    } else {
      if (emptyMsg) emptyMsg.style.display = 'none';
      container.innerHTML = cart.items.map(item => {
        const variantLabel = item.variant_title && item.variant_title !== 'Default Title' ? 
          `<div style="font-size:11px;color:#888;margin-bottom:2px">${item.variant_title}</div>` : '';
        
        const localVariant = storyProductVariants.find(v => v.id == item.variant_id);
        const comparePrice = (localVariant && localVariant.compare_at_price) ? localVariant.compare_at_price : 0;
        const hasCompare = comparePrice > item.price;
        const comparePriceHtml = hasCompare ? 
          `<span style="text-decoration:line-through;color:#bbb;font-size:11.5px;margin-left:1px">${(comparePrice/100).toLocaleString('pt-br',{style:'currency',currency:'BRL'})}</span>` : '';

        return `<div style="display:flex;gap:10px;padding:10px 0;border-bottom:1px solid #f5f5f5;align-items:center;position:relative">
          <img src="${item.image}" style="width:50px;height:50px;border-radius:8px;object-fit:cover">
          <div style="flex:1;min-width:0">
            <div style="font-weight:600;font-size:13px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding-right:20px">${item.product_title}</div>
            ${variantLabel}
            <div style="font-size:12px;color:#666">${item.quantity}x ${(item.price/100).toLocaleString('pt-br',{style:'currency',currency:'BRL'})}${comparePriceHtml}</div>
          </div>
          <button type="button" onclick="removeItemFromCart(${item.variant_id})" style="background:none;border:none;color:#ff4d4d;font-size:18px;cursor:pointer;padding:5px">✕</button>
        </div>`;
      }).join('');
    }
  }


  function initProductSheet() {
    const productSheet = document.getElementById('scav-product-sheet');
    if (!productSheet) return;

    function setupProductSheetControls() {
      const closeProdSheet = document.getElementById('scav-close-product-sheet');
      if (closeProdSheet) {
        closeProdSheet.addEventListener('click', () => {
          productSheet.style.setProperty('display', 'none', 'important');
          const card = document.getElementById('scav-story-product-card');
          if (card) card.style.setProperty('display', 'flex', 'important');
        });
      }

      document.querySelectorAll('.scav-variant-option-selector').forEach(input => {
        input.addEventListener('change', updateStoryVariant);
      });

      function setupQuantityControls() {
        const qtyInput = document.getElementById('scav-video-popup-quantity');
        if (!qtyInput) return;

        const quantityContainer = document.querySelector('.scav-sheet-qty');
        if (quantityContainer) {
          const minusBtn = quantityContainer.querySelector('.scav-qty-btn:first-child');
          const plusBtn = quantityContainer.querySelector('.scav-qty-btn:last-child');
          
          if (minusBtn) {
            const newMinusBtn = minusBtn.cloneNode(true);
            minusBtn.parentNode.replaceChild(newMinusBtn, minusBtn);
            newMinusBtn.addEventListener('click', () => {
              let value = parseInt(qtyInput.value || 1);
              if (value > 1) qtyInput.value = value - 1;
            });
          }
          
          if (plusBtn) {
            const newPlusBtn = plusBtn.cloneNode(true);
            plusBtn.parentNode.replaceChild(newPlusBtn, plusBtn);
            newPlusBtn.addEventListener('click', () => {
              let value = parseInt(qtyInput.value || 1);
              qtyInput.value = value + 1;
            });
          }
        }
      }

      setTimeout(setupQuantityControls, 100);

      // ==========================================
      // FUNÇÃO PARA PEGAR DADOS DO DATALAYER - 100% DINÂMICO
      // ==========================================
      function getProductDataFromDataLayer() {
        if (window.dataLayer) {
          for (let i = window.dataLayer.length - 1; i >= 0; i--) {
            const item = window.dataLayer[i];
            if (item.ecommerce?.items?.[0]) {
              const ecommerceItem = item.ecommerce.items[0];
              return {
                item_brand: ecommerceItem.item_brand || '',
                item_category: ecommerceItem.item_category || '',
                item_list_name: ecommerceItem.item_list_name || '',
                sku: ecommerceItem.sku || '',
                imageURL: ecommerceItem.imageURL || '',
                productURL: ecommerceItem.productURL || ''
              };
            }
          }
        }
        return {
          item_brand: '',
          item_category: '',
          item_list_name: '',
          sku: '',
          imageURL: '',
          productURL: ''
        };
      }

      // ==========================================
      // BOTÃO ADICIONAR AO CARRINHO - 100% DINÂMICO
      // ==========================================
      const addBtn = document.getElementById('scav-video-popup-add');
      if (addBtn && !addBtn.dataset.bound) {
        addBtn.dataset.bound = "true";
        addBtn.addEventListener('click', async function(e) {
          e.preventDefault();
          
          const variantSelect = document.getElementById('scav-video-popup-variant-select');
          if (!variantSelect) return;
          
          const variantId = variantSelect.value;
          const quantity = parseInt(document.getElementById('scav-video-popup-quantity').value) || 1;
          
          const originalText = this.innerText;
          this.innerText = "ADICIONANDO...";
          this.disabled = true;

          try {
            // 1. ADICIONA AO CARRINHO
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ 
                items: [{ 
                  id: variantId,
                  quantity: quantity
                }] 
              })
            });

            // ==========================================
            // PEGA OS DADOS DO PRODUTO
            // ==========================================
            const matchedVariant = storyProductVariants.find(v => v.id == variantId);
            const productId = matchedVariant?.product_id || variantId;
            const productTitle = document.querySelector('.scav-card-title')?.innerText || 'Produto';
            const productPrice = parseFloat(
              document.getElementById('scav-sheet-price')?.innerText
                ?.replace(/[^0-9,]/g, '')
                .replace(',', '.') || 0
            );

            // PEGA OS DADOS DO DATALAYER (brand, category, etc) - 100% DINÂMICO
            const productData = getProductDataFromDataLayer();

            // ==========================================
            // MONTA O ECOMMERCE - IGUAL AO DATALAYER
            // ==========================================
            var ecommerce = {
              'items': [{
                'item_id': productId.toString(),
                'content_type': 'product',
                'quantity': quantity,
                'item_variant': variantId.toString(),     
                'item_name': productTitle,
                'price': productPrice,
                'item_brand': productData.item_brand,
                'item_category': productData.item_category,
                'item_list_name': productData.item_list_name,
                'imageURL': productData.imageURL || document.getElementById('scav-sheet-variant-image')?.src || '',
                'productURL': productData.productURL || window.location.pathname,
                'sku': productData.sku || matchedVariant?.sku || ''
              }],
              'item_id_simprosys': `shopify_BR_${productId}_${variantId}`,
              'ecomm_prodid': productId.toString(),
              'ecomm_totalvalue': productPrice,
              'quantity': quantity,
              'contents': [{
                'content_ids': [productId.toString()],
                'variant_id': [variantId.toString()],
                'quantity': quantity,
                'content_type': 'product_group',
                'price': productPrice,
                'currency': 'BRL'
              }]
            };

            // ==========================================
            // ✅ DISPARA add_to_cart2 - GTM FAZ TUDO!
            // ==========================================
            if (window.dataLayer) {
              window.dataLayer.push({
                'event': 'add_to_cart2',
                ecommerce
              });
            }

            // ==========================================
            // ✅ FACEBOOK PIXEL - ÚNICO DIRETO
            // ==========================================
            if (typeof fbq === 'function') {
              fbq('track', 'AddToCart', {
                content_ids: [variantId],
                content_type: 'product',
                value: productPrice,
                currency: 'BRL'
              });
            }

            this.innerText = originalText;
            this.disabled = false;
            
            // ABRE O MINI-CART e esconde o que estava na frente
            const miniCart = document.getElementById('scav-mini-cart-sheet');
            const productSheet = document.getElementById('scav-product-sheet');
            const card = document.getElementById('scav-story-product-card');
            if (productSheet) productSheet.style.setProperty('display', 'none', 'important');
            if (card) card.style.setProperty('display', 'none', 'important');
            if (miniCart) {
              miniCart.style.setProperty('display', 'block', 'important');
              setTimeout(() => {
                miniCart.classList.add('active');
                refreshMiniCart();
              }, 10);
            }
            
            const addResult = document.getElementById('scav-sheet-add-result');
            if (addResult) {
              addResult.textContent = "✓ Produto adicionado ao carrinho!";
              addResult.classList.add("show");
              setTimeout(() => {
                addResult.classList.remove("show");
                setTimeout(() => { addResult.textContent = ""; }, 300);
              }, 2000);
            }
            
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            
          } catch (err) {
            console.error('Erro ao adicionar ao carrinho:', err);
            this.innerText = "ERRO AO ADICIONAR";
            this.disabled = false;
          }
        });
      }

      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
            if (productSheet.style.display && productSheet.style.display !== 'none') {
              setTimeout(setupQuantityControls, 150);
            }
          }
        });
      });
      observer.observe(productSheet, { attributes: true });
    }

    setupProductSheetControls();
  }

  function init() {
    const mainBtn = document.getElementById('scav-video-popup-button');
    if (mainBtn) mainBtn.addEventListener('click', scavUnlock);

    const closeStoryBtn = document.getElementById('scav-video-popup-close');
    if (closeStoryBtn) closeStoryBtn.addEventListener('click', e => { 
      e.preventDefault(); 
      e.stopPropagation(); 
      scavLockClose(); 
    });

    const closeWrapperBtn = document.getElementById('scav-popup-button-close');
    if (closeWrapperBtn) closeWrapperBtn.addEventListener('click', e => { 
      e.preventDefault(); 
      e.stopPropagation(); 
      const wrapper = document.getElementById('scav-video-popup-button-wrapper');
      if (wrapper) wrapper.style.setProperty('display', 'none', 'important');
      scavLockClose(); 
    });

    const overlayElement = document.getElementById('scav-video-popup-overlay');
    if (overlayElement) overlayElement.addEventListener('click', e => { 
      if (e.target === overlayElement) scavLockClose(); 
    });

     const openSheetBtn = document.getElementById('scav-open-product-sheet');
    if (openSheetBtn) openSheetBtn.addEventListener('click', () => { 
        const sheet = document.getElementById('scav-product-sheet');
        const card = document.getElementById('scav-story-product-card');
        if (card) card.style.setProperty('display', 'none', 'important');
        if (sheet) sheet.style.setProperty('display', 'block', 'important'); 
    });

    const openMiniBtn = document.getElementById('scav-open-mini-cart');
    if (openMiniBtn) openMiniBtn.addEventListener('click', () => {
      const mc = document.getElementById('scav-mini-cart-sheet');
      const sheet = document.getElementById('scav-product-sheet');
      const card = document.getElementById('scav-story-product-card');
      if (sheet) sheet.style.setProperty('display', 'none', 'important');
      if (card) card.style.setProperty('display', 'none', 'important');
      if (mc) {
        mc.style.setProperty('display', 'block', 'important');
        setTimeout(() => { 
          mc.classList.add('active'); 
          refreshMiniCart(); 
        }, 10);
      }
    });

    const closeMiniBtn = document.getElementById('scav-close-mini-cart');
    if (closeMiniBtn) closeMiniBtn.addEventListener('click', () => {
      const mc = document.getElementById('scav-mini-cart-sheet');
      if (mc) {
        mc.classList.remove('active');
        setTimeout(() => {
          mc.style.setProperty('display', 'none', 'important');
          // Restaura só o card, product-sheet fica fechado
          const sheet = document.getElementById('scav-product-sheet');
          const card = document.getElementById('scav-story-product-card');
          if (sheet) {
            sheet.classList.remove('active');
            sheet.style.setProperty('display', 'none', 'important');
          }
          if (card) card.style.setProperty('display', 'flex', 'important');
        }, 350);
      }
    });

    initProductSheet();

    document.addEventListener('cart:refresh', refreshMiniCart);
    document.addEventListener('cart:updated', refreshMiniCart);
    
    setTimeout(() => {
      const productSheet = document.getElementById('scav-product-sheet');
      if (productSheet && productSheet.style.display !== 'none') initFreteCalculator();
    }, 200);
    
    refreshMiniCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ==========================================
// CONTROLES DE VÍDEO
// ==========================================
(function() {
  const injectCSS = () => {
    if (document.getElementById('scav-video-styles')) return;
    const style = document.createElement('style');
    style.id = 'scav-video-styles';
    style.textContent = `.scav-video-popup-overlay,.scav-video-popup-content,.scav-story-product-card{content-visibility:auto;contain:layout paint style;will-change:transform,opacity;transform:translateZ(0)}.scav-video-popup-button{will-change:transform,opacity;transform:translateZ(0)}.scav-story-video{backface-visibility:hidden;transform:translateZ(0);will-change:opacity}.scav-video-popup-content{contain:strict;isolation:isolate}.scav-video-popup-button:active{transform:scale(.96)}.scav-video-popup-button .scav-button-preview{width:100%;height:100%;object-fit:cover;pointer-events:none;border-radius:50%}.scav-video-popup-overlay{display:none;position:fixed;inset:0;background:rgb(0 0 0/.98);justify-content:center;align-items:center;z-index:2147483647;backface-visibility:hidden;contain:layout paint;overscroll-behavior:contain}.scav-video-popup-overlay.active{display:flex}.scav-video-popup-content{position:relative;background:#000;border-radius:0;overflow:hidden;box-shadow:none;width:100%;height:100%;max-width:100%;max-height:100%;aspect-ratio:unset}@media (min-width:769px){.scav-video-popup-content{width:100%;max-width:420px;height:auto;max-height:85vh;border-radius:20px;box-shadow:0 0 40px rgb(0 0 0/.6);aspect-ratio:9/16}}@media (min-width:481px) and (max-width:768px){.scav-video-popup-content{width:calc(100vw - 60px);max-width:400px;height:calc(100vh - 120px);border-radius:20px;box-shadow:0 0 40px rgb(0 0 0/.6)}}.scav-video-container{width:100%;height:100%;position:relative;contain:strict}.scav-story-video{display:none;width:100%;height:100%;object-fit:cover}.scav-story-video.active{display:block;animation:fadeIn .35s ease-out}@keyframes fadeIn{from{opacity:0}to{opacity:1}}.scav-story-progress{position:absolute;top:env(safe-area-inset-top, 10px);left:0;right:0;height:3px;gap:4px;padding:0 10px;display:flex;z-index:10}.scav-progress-bar{flex:1;border-radius:2px;overflow:hidden;background:rgb(255 255 255/.2)}.scav-progress-inner{width:0;height:100%;background:#fff;transition:width linear;will-change:width}.scav-story-zones{position:absolute;inset:0;display:flex;z-index:5}.scav-tap-zone{flex:1}.scav-story-controls-top{position:absolute;top:calc(env(safe-area-inset-top, 10px) + 15px);right:calc(env(safe-area-inset-right, 10px) + 10px);display:flex;align-items:center;gap:8px;z-index:20}.scav-story-btn{background:rgb(255 255 255 / 11%);color:#fff;border-radius:50%;width:36px;height:36px;display:flex;align-items:center;justify-content:center;cursor:pointer;transition:background .25s ease,transform .2s ease;will-change:background,transform}.scav-story-btn:active{transform:scale(.92)}.scav-close-btn svg{width:22px;height:22px}.scav-story-product-card{position:absolute;bottom:calc(env(safe-area-inset-bottom, 10px) + 10px);left:calc(env(safe-area-inset-left, 10px) + 10px);right:calc(env(safe-area-inset-right, 10px) + 10px);background:rgba(60,65,80,.82);border-radius:16px;padding:12px;display:flex;align-items:stretch;gap:0;z-index:50;box-shadow:0 8px 22px rgb(0 0 0/.45);animation:slideUp .28s ease-out;backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);transform:translateZ(0);contain:layout style;max-width:calc(100%);margin:0}@keyframes slideUp{from{transform:translateY(22px) scale(.98);opacity:0}to{transform:translateY(0) scale(1);opacity:1}}.scav-card-inner{flex:1;display:flex;flex-direction:column;gap:10px;min-width:0}.scav-card-top-row{display:flex;align-items:center;gap:10px}.scav-story-product-card .scav-card-left{width:56px;height:56px;flex:0 0 auto;display:flex;align-items:center;justify-content:center;overflow:hidden;border-radius:10px;background:rgba(255,255,255,.12)}.scav-story-product-card .scav-card-left img{width:100%;height:100%;object-fit:cover;border-radius:8px}.scav-story-product-card .scav-card-middle{flex:1 1 auto;min-width:0;display:flex;flex-direction:column;gap:3px}.scav-story-product-card .scav-card-title{font-size:13px;font-weight:600;color:#fff;line-height:1.25em;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.scav-story-product-card .scav-card-price{font-size:15px;font-weight:400;color:#fff}.scav-card-saiba-btn{background:#1D3C86;color:#fff;font-size:13px;font-weight:700;border:none;border-radius:10px;padding:10px 14px;width:100%;cursor:pointer;display:flex;align-items:center;justify-content:space-between;transition:opacity .15s ease;letter-spacing:.02em}.scav-card-saiba-btn:active{opacity:.85}.scav-card-actions{display:flex;flex-direction:column;justify-content:space-between;align-items:center;padding:4px 0 4px 12px;gap:10px;position:absolute;right:calc(-56px);bottom:calc(env(safe-area-inset-bottom, 10px) + 10px);width:48px}.scav-action-btn{width:44px;height:44px;border-radius:50%;background:rgba(80,85,100,.75);border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#fff;transition:transform .15s ease,background .15s ease;backdrop-filter:blur(6px)}.scav-action-btn:active{transform:scale(.9)}.scav-whatsapp-btn{background:}.scav-product-sheet{position:absolute;left:0;right:0;bottom:0;z-index:100;transform:translateY(105%);transition:transform .35s cubic-bezier(.16,1,.3,1);background:#fff;border-radius:20px 20px 0 0;box-shadow:0 -10px 30px rgb(0 0 0/.3);touch-action:pan-y;max-height:90vh;overflow:hidden;width:100%}.scav-product-sheet.active{transform:translateY(0)}.scav-sheet-handle{width:40px;height:4px;background:rgb(0 0 0/.1);border-radius:2px;margin:12px auto}.scav-sheet-body{padding:0 20px 20px;display:flex;flex-direction:column;gap:15px;max-height:calc(90vh - 60px);overflow-y:auto;overscroll-behavior:contain;touch-action:pan-y;-webkit-overflow-scrolling:touch}.scav-sheet-header-compact{display:flex;align-items:center;gap:12px;padding-bottom:12px;border-bottom:1px solid #f5f5f5}#scav-sheet-variant-image{width:70px;height:70px;object-fit:cover;border-radius:8px}.scav-sheet-price{font-size:18px;font-weight:500;color:#000}.scav-sheet-label{font-size:11px;color:#999;text-transform:uppercase;font-weight:700;margin-bottom:8px;display:block}.scav-video-popup-variant-groups{display:flex;flex-direction:column;gap:16px}.scav-variant-group{display:flex;flex-direction:column}.scav-video-popup-swatches{display:flex;flex-wrap:wrap;gap:8px;margin-top:4px}.scav-swatch-element{position:relative}.scav-swatch-input{position:absolute;opacity:0;width:0;height:0}.scav-swatch-label{display:inline-block;padding:8px 16px;border:1.5px solid #eee;border-radius:10px;font-size:13px;font-weight:600;cursor:pointer;transition:all 0.2s cubic-bezier(.4,0,.2,1);background:#fafafa;color:#444;text-align:center;min-width:44px}.scav-swatch-input:checked+.scav-swatch-label{border-color:#000;background-color:#000;color:#fff;box-shadow:0 4px 10px rgb(0 0 0/.15)}.scav-sheet-qty-row{display:flex;align-items:center;justify-content:space-between;margin-top:8px}.scav-sheet-qty{display:flex;align-items:center;background:#f4f4f4;border-radius:10px;padding:2px}.scav-qty-btn{background:#fff0;border:none;width:36px;height:36px;cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:20px}.scav-qty-input{width:40px;text-align:center;border:none;background:#fff0;font-weight:700;font-size:15px}.scav-sheet-add-btn{background:#1D3C86;color:#fff;width:100%;height:52px;border-radius:14px;font-weight:600;font-size:14px;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;margin-top:5px;transition:opacity 0.2s}.scav-sheet-add-btn:disabled{background:#ccc;cursor:not-allowed}.scav-sheet-add-result{font-size:13px;text-align:center;color:#2b7a2b;min-height:18px;font-weight:500;opacity:0;transition:opacity 0.3s ease}.scav-sheet-add-result.show{opacity:1}.scav-sheet-close-x{position:absolute;top:12px;right:15px;width:28px;height:28px;background:#eee;border-radius:50%;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;font-weight:700;color:#333;z-index:110;font-size:14px}@media (max-width:768px){.scav-video-popup-overlay{background:rgb(0 0 0/.98)}.scav-story-product-card{left:calc(env(safe-area-inset-left, 8px) + 8px);right:calc(env(safe-area-inset-right, 8px) + 8px);bottom:calc(env(safe-area-inset-bottom, 8px) + 8px);padding:10px;border-radius:14px;gap:10px}.scav-story-product-card .scav-card-left{width:56px}.scav-story-product-card .scav-card-title{font-size:13px}.scav-story-product-card .scav-card-buy-btn{padding:7px 12px;font-size:13px}.scav-sheet-body{padding:0 15px 20px}.scav-story-controls-top{top:calc(env(safe-area-inset-top, 20px) + 20px);right:calc(env(safe-area-inset-right, 8px) + 8px)}.scav-story-btn{width:40px;height:40px}.scav-sheet-header-compact{gap:10px}#scav-sheet-variant-image{width:60px;height:60px}}@media (max-width:360px){.scav-story-product-card{left:calc(env(safe-area-inset-left, 6px) + 6px);right:calc(env(safe-area-inset-right, 6px) + 6px);bottom:calc(env(safe-area-inset-bottom, 6px) + 6px);padding:8px;border-radius:12px;gap:8px}.scav-story-product-card .scav-card-left{width:48px}.scav-story-product-card .scav-card-title{font-size:12px}.scav-story-product-card .scav-card-buy-btn{padding:6px 10px;font-size:12px}.scav-sheet-body{padding:0 12px 20px}.scav-sheet-header-compact{gap:8px}#scav-sheet-variant-image{width:50px;height:50px}.scav-sheet-price{font-size:16px}.scav-swatch-label{padding:6px 12px;font-size:12px;min-width:40px}.scav-qty-btn{width:32px;height:32px;font-size:18px}.scav-sheet-add-btn{height:48px;font-size:13px}}@media (max-width:320px){.scav-story-progress{top:calc(env(safe-area-inset-top, 8px) + 8px);padding:0 8px}.scav-story-controls-top{top:calc(env(safe-area-inset-top, 15px) + 15px);right:calc(env(safe-area-inset-right, 6px) + 6px);gap:6px}.scav-story-btn{width:28px;height:28px}.scav-close-btn svg{width:18px;height:18px}.scav-story-product-card{flex-wrap:wrap;justify-content:space-between}.scav-story-product-card .scav-card-middle{order:3;flex:1 1 100%;margin-top:8px}.scav-video-popup-swatches{gap:6px}.scav-swatch-label{padding:5px 10px;font-size:11px;min-width:36px}}@supports (padding:max(0px)){.scav-story-progress{top:max(10px,env(safe-area-inset-top))}.scav-story-controls-top{top:max(25px,calc(env(safe-area-inset-top) + 15px));right:max(10px,calc(env(safe-area-inset-right) + 10px))}.scav-story-product-card{left:max(10px,calc(env(safe-area-inset-left) + 10px));right:max(10px,calc(env(safe-area-inset-right) + 10px));bottom:max(10px,calc(env(safe-area-inset-bottom) + 10px))}}@media (orientation:landscape) and (max-width:768px){.scav-story-product-card{bottom:calc(env(safe-area-inset-bottom, 6px) + 6px);padding:8px;gap:8px}.scav-story-product-card .scav-card-left{width:48px}.scav-story-product-card .scav-card-title{font-size:12px}.scav-sheet-body{max-height:calc(100vh - 100px)}.scav-story-controls-top{top:calc(env(safe-area-inset-top, 10px) + 10px);right:calc(env(safe-area-inset-right, 10px) + 10px)}}@media (min-height:800px) and (max-width:768px){.scav-product-sheet{max-height:85vh}.scav-sheet-body{max-height:calc(85vh - 60px)}}.scav-fullscreen-mode{position:fixed!important;top:0!important;left:0!important;width:100vw!important;height:100vh!important;max-width:100%!important;max-height:100%!important;border-radius:0!important;z-index:10001!important}`;
    document.head.appendChild(style);
  };

  const init = () => {
    injectCSS();
    
    const wrapper = document.getElementById("scav-video-popup-button-wrapper");
    const btn = document.getElementById("scav-video-popup-button");
    const overlay = document.getElementById("scav-video-popup-overlay");
    const closePopup = document.getElementById("scav-video-popup-close");
    const removeBtn = document.getElementById("scav-popup-button-close");
    const muteBtn = document.getElementById("scav-mute-story");
    const pauseBtn = document.getElementById("scav-pause-story");
    const soundIcon = document.getElementById("scav-sound-icon");
    const pauseIcon = document.getElementById("scav-pause-icon");
    const videos = Array.from(document.querySelectorAll(".scav-story-video"));
    const bars = Array.from(document.querySelectorAll(".scav-progress-inner"));
    const zoneLeft = document.getElementById("scav-tap-left");
    const zoneRight = document.getElementById("scav-tap-right");
    const productCard = document.getElementById("scav-story-product-card");
    const openProductSheetBtn = document.getElementById("scav-open-product-sheet");
    const productSheet = document.getElementById("scav-product-sheet");
    const closeSheetBtn = document.getElementById("scav-close-product-sheet");

    if(!wrapper || !btn || videos.length === 0) return;

    function isMobile() {
      return window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    let index = 0, rafId = null, isMuted = false, isPaused = false;
    let dragging = false, dragX = 0, dragY = 0;

    function startDrag(ev){
      if(ev.target !== btn && !btn.contains(ev.target)) return;
      dragging = true;
      const rect = wrapper.getBoundingClientRect();
      const x = ev.touches ? ev.touches[0].clientX : ev.clientX;
      const y = ev.touches ? ev.touches[0].clientY : ev.clientY;
      dragX = x - rect.left;
      dragY = y - rect.top;
      wrapper.style.transition = "none";
    }

    function onDrag(ev){
      if(!dragging) return;
      ev.preventDefault();
      const x = ev.touches ? ev.touches[0].clientX : ev.clientX;
      const y = ev.touches ? ev.touches[0].clientY : ev.clientY;
      const maxX = window.innerWidth - wrapper.offsetWidth;
      const maxY = window.innerHeight - wrapper.offsetHeight;
      let left = x - dragX;
      let top = y - dragY;
      left = Math.max(0, Math.min(left, maxX));
      top = Math.max(0, Math.min(top, maxY));
      wrapper.style.left = left + "px";
      wrapper.style.top = top + "px";
      wrapper.style.bottom = "auto";
    }

    function endDrag(){ dragging = false; wrapper.style.transition = "left .1s ease, top .1s ease"; }

    function resetBars(){ bars.forEach(b => b.style.width = "0%"); cancelAnimationFrame(rafId); rafId = null; }

    function stopAll(){ videos.forEach(v => { v.pause(); v.currentTime = 0; }); }

    function animateBar(){
      const bar = bars[index];
      const video = videos[index];
      if(!bar || !video || isPaused) { rafId = requestAnimationFrame(animateBar); return; }
      if(video.duration > 0) {
        const progress = (video.currentTime / video.duration) * 100;
        bar.style.width = progress.toFixed(4) + "%";
        if(video.ended || video.currentTime >= video.duration) {
          bar.style.width = "100%";
          nextStory();
          return;
        }
      }
      rafId = requestAnimationFrame(animateBar);
    }

    function playStory(i){
      index = i;
      isPaused = false;
      updatePauseIcon(false);
      videos.forEach((v, idx) => { v.pause(); v.classList.toggle("active", idx === i); });
      const video = videos[i];
      if(!video) return;
      video.currentTime = 0;
      video.muted = isMuted;
      bars.forEach(b => b.style.width = "0%");
      cancelAnimationFrame(rafId);
      video.play().then(() => { rafId = requestAnimationFrame(animateBar); }).catch(() => { rafId = requestAnimationFrame(animateBar); });
    }

    function nextStory(){
      videos[index]?.pause();
      if(index >= videos.length - 1) {
        index = 0;
        playStory(index);
      } else {
        index++;
        playStory(index);
      }
    }

    function prevStory(){
      videos[index]?.pause();
      if(index > 0) {
        index--;
        playStory(index);
      } else {
        playStory(0);
      }
    }

    function closePopupAction(){
      overlay.classList.remove("active");
      productCard?.classList.remove("active");
      stopAll();
      resetBars();
      index = 0;
      isPaused = false;
      updatePauseIcon(false);
      hideProductSheet();
    }

    function updatePauseIcon(paused){
      if(!pauseIcon) return;
      pauseIcon.innerHTML = paused
        ? '<svg viewBox="0 0 24 24" width="24" height="24" fill="white"><polygon points="5 3 19 12 5 21 5 3"></polygon></svg>'
        : '<svg viewBox="0 0 24 24" width="24" height="24" fill="white"><rect x="6" y="4" width="4" height="16"></rect><rect x="14" y="4" width="4" height="16"></rect></svg>';
    }

    function updateSoundIcon(){
  if(!soundIcon) return;
  soundIcon.innerHTML = isMuted
    ? `<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" fill="white" stroke="none"></polygon>
        <line x1="23" y1="9" x2="17" y2="15"></line>
        <line x1="17" y1="9" x2="23" y2="15"></line>
      </svg>`
    : `<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" fill="white" stroke="none"></polygon>
        <path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>
        <path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path>
      </svg>`;
}

    function showProductSheet(){
      productSheet?.classList.add("active");
      isPaused = true;
      videos[index]?.pause();
      updatePauseIcon(true);
    }

    function hideProductSheet(){
      productSheet?.classList.remove("active");
      const addResult = document.getElementById('scav-sheet-add-result');
      if (addResult) {
        addResult.classList.remove("show");
        setTimeout(() => { addResult.textContent = ""; }, 300);
      }
    }

    if(openProductSheetBtn) openProductSheetBtn.addEventListener("click", showProductSheet);
    if (closeSheetBtn) closeSheetBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      hideProductSheet();
      isPaused = false;
      videos[index]?.play().catch(() => {});
      updatePauseIcon(false);
    });

    // WhatsApp: compartilha o link do produto com nome e preço
    const whatsappBtn = document.querySelector('.scav-whatsapp-btn');
    if (whatsappBtn) {
      whatsappBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        const productTitle = document.querySelector('.scav-card-title')?.innerText || document.title;
        const productPrice = document.getElementById('scav-card-main-price')?.innerText || '';
        const productUrl   = window.location.href;
        const msg = `Olha esse produto que encontrei: *${productTitle}*${productPrice ? ' — ' + productPrice : ''}\n${productUrl}`;
        const waUrl = 'https://wa.me/?text=' + encodeURIComponent(msg);
        window.open(waUrl, '_blank');
      });
    }

    btn.addEventListener("click", () => {
      index = 0;
      overlay.classList.add("active");
      if (isMobile()) {
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
      }
      playStory(index);
    });

    closePopup.addEventListener("click", () => {
      closePopupAction();
      if (isMobile()) {
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
      }
    });
    
    removeBtn.addEventListener("click", () => {
      wrapper.style.display = "none";
      if (isMobile()) {
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
      }
    });
    
    zoneLeft.addEventListener("click", (e) => { e.stopPropagation(); prevStory(); });
    zoneRight.addEventListener("click", (e) => { e.stopPropagation(); nextStory(); });

    pauseBtn.addEventListener("click", () => {
      isPaused = !isPaused;
      updatePauseIcon(isPaused);
      isPaused ? videos[index].pause() : videos[index]?.play().catch(() => {});
    });

    muteBtn.addEventListener("click", () => {
      isMuted = !isMuted;
      updateSoundIcon();
      videos.forEach(v => v.muted = isMuted);
    });

    document.addEventListener("mousedown", startDrag);
    document.addEventListener("mousemove", onDrag);
    document.addEventListener("mouseup", endDrag);
    document.addEventListener("touchstart", startDrag, {passive: false});
    document.addEventListener("touchmove", onDrag, {passive: false});
    document.addEventListener("touchend", endDrag);

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && overlay.classList.contains('active')) {
        closePopupAction();
        if (isMobile()) {
          document.documentElement.style.overflow = '';
          document.body.style.overflow = '';
        }
      }
    });
  };

  function positionWrapper() {
    const wrapper = document.getElementById('scav-video-popup-button-wrapper');
    if (!wrapper) return;

    const header = document.querySelector('hdt-sticky-header');
    const headerH = header ? header.offsetHeight : 0;
    const GAP = 16;

    const isMobile = window.innerWidth < 769;

    if (isMobile) {
      // Celular: canto superior esquerdo, abaixo do header
      wrapper.style.top    = (headerH + -15) + 'px';
      wrapper.style.left   = '5px';
      wrapper.style.bottom = 'auto';
      wrapper.style.right  = 'auto';
    } else {
      // Desktop: canto superior esquerdo do slider principal de imagens
      const mediaMain = document.querySelector('.hdt-product-media__main');
      if (mediaMain) {
        const rect = mediaMain.getBoundingClientRect();
        wrapper.style.top    = rect.top + 'px';
        wrapper.style.left   = rect.left + 'px';
        wrapper.style.bottom = 'auto';
        wrapper.style.right  = 'auto';
      } else {
        // fallback
        wrapper.style.top    = (headerH + GAP) + 'px';
        wrapper.style.left   = '16px';
        wrapper.style.bottom = 'auto';
        wrapper.style.right  = 'auto';
      }
    }
  }

  function safeInit() {
    // Move o overlay para o <body> para escapar do stacking context do tema
    const overlay = document.getElementById('scav-video-popup-overlay');
    if (overlay && overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }
    // Move o wrapper do botão para o <body> pelo mesmo motivo
    const wrapper = document.getElementById('scav-video-popup-button-wrapper');
    if (wrapper && wrapper.parentElement !== document.body) {
      document.body.appendChild(wrapper);
    }

    // Posiciona assim que possível e re-posiciona no resize
    positionWrapper();
    window.addEventListener('resize', positionWrapper);

    // Re-posiciona após imagens/layout carregarem (slider pode mudar de altura)
    window.addEventListener('load', positionWrapper);

    init();
  }

  if(document.readyState === "complete" || document.readyState === "interactive"){
    safeInit();
  } else {
    document.addEventListener("DOMContentLoaded", safeInit);
  }
})();

// ==========================================
// BACKUP PARA VARIANTES (COMPATIBILIDADE)
// ==========================================
(function() {
    const storyProductVariants = window.scavProductConfig ? window.scavProductConfig.variants : [];

    function scavUnlock() {
        const overlay = document.getElementById('scav-video-popup-overlay');
        const productCard = document.getElementById('scav-story-product-card');
        
        if (overlay) {
            // Força z-index máximo para garantir que nada fique na frente
            overlay.style.setProperty('display', 'flex', 'important');
            overlay.style.setProperty('z-index', '2147483647', 'important');
            overlay.style.setProperty('position', 'fixed', 'important');
            
            document.querySelectorAll('.scav-story-video').forEach(video => {
                if (!video.src || video.src === "") {
                    const realSrc = video.getAttribute('data-src');
                    if (realSrc) {
                        video.src = realSrc;
                        const source = video.querySelector('source');
                        if (source) source.src = realSrc;
                        video.load();
                    }
                }
            });
            overlay.classList.add('active');
        }
        if (productCard) {
            productCard.style.setProperty('display', 'flex', 'important');
            productCard.style.setProperty('z-index', '9999999', 'important');
        }
    }

    function scavLockClose() {
        ['scav-video-popup-overlay', 'scav-story-product-card', 'scav-mini-cart-sheet', 'scav-product-sheet'].forEach(id => {
            const el = document.getElementById(id);
            if (el) {
                el.style.setProperty('display', 'none', 'important');
                el.classList.remove('active');
            }
        });
        document.querySelectorAll('.scav-story-video').forEach(v => {
            v.pause();
            v.currentTime = 0;
        });
    }

    const mainBtn = document.getElementById('scav-video-popup-button');
    if (mainBtn) mainBtn.addEventListener('click', scavUnlock);

    const closeStoryBtn = document.getElementById('scav-video-popup-close');
    if (closeStoryBtn) closeStoryBtn.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); scavLockClose(); });

    const closeWrapperBtn = document.getElementById('scav-popup-button-close');
    if (closeWrapperBtn) closeWrapperBtn.addEventListener('click', e => { 
        e.preventDefault(); e.stopPropagation(); 
        const wrapper = document.getElementById('scav-video-popup-button-wrapper');
        if (wrapper) wrapper.style.setProperty('display', 'none', 'important');
        scavLockClose(); 
    });

    const overlayElement = document.getElementById('scav-video-popup-overlay');
    if (overlayElement) overlayElement.addEventListener('click', e => { if (e.target === overlayElement) scavLockClose(); });

      const openSheetBtn = document.getElementById('scav-open-product-sheet');
    if (openSheetBtn) openSheetBtn.addEventListener('click', () => { 
        const sheet = document.getElementById('scav-product-sheet');
        const card = document.getElementById('scav-story-product-card');
        if (card) card.style.setProperty('display', 'none', 'important');
        if (sheet) sheet.style.setProperty('display', 'block', 'important'); 
    });

    window.updateStoryVariant = function() {
        const selectedOptions = Array.from(document.querySelectorAll('.scav-variant-option-selector:checked')).map(el => el.value);
        const matchedVariant = storyProductVariants.find(v => v.options.every((opt, i) => opt === selectedOptions[i]));
        if (!matchedVariant) return;

        const variantSelect = document.getElementById('scav-video-popup-variant-select');
        const priceVal = (matchedVariant.price / 100).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
        
        const sheetPrice = document.getElementById('scav-sheet-price');
        const cardPrice = document.getElementById('scav-card-main-price');
        if (sheetPrice) sheetPrice.innerText = priceVal;
        if (cardPrice) cardPrice.innerText = priceVal;
        if (variantSelect) variantSelect.value = matchedVariant.id.toString();

        const sheetComp = document.getElementById('scav-sheet-compare-price');
        const cardComp = document.getElementById('scav-card-compare-price');
        const hasCompare = matchedVariant.compare_at_price > matchedVariant.price;
        
        if (hasCompare) {
            const compVal = (matchedVariant.compare_at_price / 100).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
            if (sheetComp) { sheetComp.innerText = compVal; sheetComp.style.display = 'inline-block'; }
            if (cardComp) { cardComp.innerText = compVal; cardComp.style.display = 'inline-block'; }
        } else {
            if (sheetComp) sheetComp.style.display = 'none';
            if (cardComp) cardComp.style.display = 'none';
        }

        if (matchedVariant.featured_image) {
            const imgElement = document.getElementById('scav-sheet-variant-image');
            if (imgElement) imgElement.src = matchedVariant.featured_image.src;
        }

        const addBtn = document.getElementById('scav-video-popup-add');
        if (addBtn) {
            addBtn.disabled = !matchedVariant.available;
            addBtn.innerText = matchedVariant.available ? "Adicionar ao Carrinho" : "Esgotado";
            addBtn.style.opacity = matchedVariant.available ? "1" : "0.5";
        }
    };

    document.querySelectorAll('.scav-variant-option-selector').forEach(input => {
        input.addEventListener('change', window.updateStoryVariant);
    });
})();